import React, { FC, useEffect, useState } from 'react';
import CalenderYear from './calender-year';
import Prices from '../prices/prices';
import * as CSS from './availability.styles';
import { PageContainer, CommonPageContent, CommonPageHeader } from '../common-styles/common-styles';
import { useAvailabilityQueryPimsCalendar, Price, useAvailabilityQuery } from '../../api/availability';
import { Spinner } from '../spinner/spinner';
import { createCalenders } from '../../utils/bookings/create-calendars';
import { Calendar } from '../../utils/bookings/booking-types';

export type MonthBookedAvailability = Record<string, number[]>;
export const Availability: FC = () => {
  const [calendars, setCalendars] = useState<Array<Calendar>>([]);
  const [prices, setPrices] = useState<Price[]>([]);
  const { data: calData, error: calError, isLoading: calIsLoading } = useAvailabilityQueryPimsCalendar();
  const { data, error, isLoading } = useAvailabilityQuery();

  useEffect(() => {
    if (calData && calData.length > 0) {
      const calendars = createCalenders(calData);
      setCalendars(calendars);
    }
  }, [calData]);

  useEffect(() => {
    if (data) {
      setPrices(data.prices);
    }
  }, [data]);

  if (isLoading || calIsLoading) {
    return <Spinner />;
  }
  if (error || calError || !data || !prices || !calData) {
    return <div>ERROR</div>;
  }

  return (
    <PageContainer>
      <CommonPageContent>
        <Prices prices={prices} />
      </CommonPageContent>
      <CommonPageContent data-testid="availability">
        <CommonPageHeader>Availability</CommonPageHeader>
        <CSS.AvailabilityKeys>
          <CSS.AvailabilityKeyAvailable>Available</CSS.AvailabilityKeyAvailable>
          <CSS.AvailabilityKeyUnavailable>Booked</CSS.AvailabilityKeyUnavailable>
        </CSS.AvailabilityKeys>
        <div>
          {calData && calData.length === 0 && <div>Sorry, we are having problems retrieving the availability!, Please try again later.</div>}
          {calendars?.length > 0 &&
            calendars.map((calendar: Calendar, index: number) => {
              return <CalenderYear key={`cal-${calendar.year}-${index}`} calendar={calendar} />;
            })}
        </div>
      </CommonPageContent>
    </PageContainer>
  );
};
